import React, { useState } from "react";
import {
  Container, TextField, Button, Typography, Box,
  FormControl, InputLabel, Select, MenuItem
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { useTranslation } from "react-i18next";
import BackToDashboard from "../common/BackToAdminDashboard";

const AddProduct = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    external_id: "",
    name_en: "",
    name_el: "",
    subtitle_en: "",
    subtitle_el: "",
    country_origin: "",
    quantity: "",
    unit_en: "",
    unit_el: ""
  });
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError(null);
    try {
      await api.products.add({
        ...form,
        country_origin: parseInt(form.country_origin, 10),
        quantity:       parseInt(form.quantity, 10)
      });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err.response?.data?.error || t("failed_to_add_product"));
    }
  };

  return (
    <Container sx={{ mt: 4 }}>
      <BackToDashboard dashboardPath="/admin/dashboard" />
      <Typography variant="h4" gutterBottom>
        {t("add_product")}
      </Typography>
      {error && <Typography color="error">{error}</Typography>}

      <form onSubmit={handleSubmit}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label={t("external_id")}
            name="external_id"
            fullWidth
            value={form.external_id}
            onChange={handleChange}
          />
          <TextField
            label={t("name_en")}
            name="name_en"
            fullWidth
            required
            value={form.name_en}
            onChange={handleChange}
          />
          <TextField
            label={t("name_el")}
            name="name_el"
            fullWidth
            required
            value={form.name_el}
            onChange={handleChange}
          />
          <TextField
            label={t("subtitle_en")}
            name="subtitle_en"
            fullWidth
            value={form.subtitle_en}
            onChange={handleChange}
          />
          <TextField
            label={t("subtitle_el")}
            name="subtitle_el"
            fullWidth
            value={form.subtitle_el}
            onChange={handleChange}
          />
          <FormControl fullWidth required>
            <InputLabel>{t("country_origin")}</InputLabel>
            <Select
              name="country_origin"
              value={form.country_origin}
              onChange={handleChange}
              label={t("country_origin")}
            >
              <MenuItem value={1}>Ελλάδα</MenuItem>
              <MenuItem value={2}>USA</MenuItem>
              <MenuItem value={3}>UK</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label={t("quantity")}
            name="quantity"
            type="number"
            fullWidth
            required
            value={form.quantity}
            onChange={handleChange}
          />
          <TextField
            label={t("unit_en")}
            name="unit_en"
            fullWidth
            value={form.unit_en}
            onChange={handleChange}
          />
          <TextField
            label={t("unit_el")}
            name="unit_el"
            fullWidth
            value={form.unit_el}
            onChange={handleChange}
          />
          <Button variant="contained" color="primary" type="submit">
            {t("add_product")}
          </Button>
        </Box>
      </form>
    </Container>
  );
};

export default AddProduct;
